<template>
  <div class="openIndex" @click="hidePop">
    <!-- 左边批次模块 -->
    <div class="batch_box">
      
      <!-- <div class="batch_title">批次列表</div> -->
      <div class="batch_btns">
        <span @click="changeTab('batch')" :class="b_active.btn_name == 'batch'?'active br4':'br4'">批次</span>
        <span @click="changeTab('cate')" :class="b_active.btn_name == 'cate'?'active br4':'br4'">分类</span>
        <span @click="changeTab('fee')" fee :class="b_active.btn_name == 'fee'?'active br4':'br4'">附加费</span>
      </div>
      <!-- 批次列表 -->
      <div class="batch_list brt4" :show="b_active.btn_name != 'cate'">
        <md-scroll-view ref="b_b_scrollView" :scrolling-x="false" :auto-reflow="true" manual-init @end-reached="handleGetBatchMore">
          <!-- <md-scroll-view-refresh roller-color="#31B158" slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }" :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive" ></md-scroll-view-refresh> -->
          <div
            :class="(item.id == g_listQuery.batch_id && b_active.btn_name == 'batch') ? 'batch_item active':'batch_item'"
            v-for="(item,index) in b_batchList"
            :key="index"
            @click="changeBatch(item)"
          >
            <div class="batch_item_name mand-ellipsis">{{item.name}}</div>
            <div class="batch_item_num">{{item.purchase_num | addZero}}</div>
          </div>
          <md-scroll-view-more :finished-text="b_batchList.length>0?'全部已加载':'暂无数据'" slot="more" :is-finished="b_b_isFinished" > </md-scroll-view-more>
        </md-scroll-view>
      </div>
      <!-- 分类列表 -->
      <div class="batch_list brt4 cate_list" :show="b_active.btn_name == 'cate'">
        <md-scroll-view ref="b_c_scrollView" :scrolling-x="false" :auto-reflow="true">
          <!-- <md-scroll-view-refresh roller-color="#31B158" slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }" :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive" ></md-scroll-view-refresh> -->
          <div :class="item.id == g_listQuery.cate_id ? 'batch_item active':'batch_item'" v-for="(item,index) in b_cateList"
            :key="index" @click="changeCate(item)" >
            <div class="batch_item_name mand-ellipsis">{{item.name}}</div>
            <!-- <div class="batch_item_num">{{item.supplier_sn}}</div> -->
          </div>
          <md-scroll-view-more :finished-text="b_cateList.length>0?'全部已加载':'暂无数据'" slot="more" :is-finished="b_c_isFinished" > </md-scroll-view-more>
        </md-scroll-view>
      </div>
    </div>

    <!-- 中间商品模块 -->
    <div class="goods_box">
      <!-- 搜索条 -->
      <!--  v-if="g_goodsList.length>-20 || g_listQuery.name.length>0"  :h-100="!(g_goodsList.length>-20 || g_listQuery.name.length>0)"-->
      <div class="goods_search list_search brb4">
        <input type="text" v-model="g_listQuery.name" @input="handleGoodsSearch()" placeholder="搜索商品名称" />
        <span class="icon_search"><i class="iconfont icon-sousuo" style="color:#888"></i></span>
        <span class="icon_close" v-if="g_listQuery.name" @click="g_listQuery.name = '';handleGoodsSearch()">
          <i class="iconfont icon-guanbi" style="color:#888"></i>
        </span>
      </div>
      <!-- 商品列表 -->
      <div class="goods_container">
        <div class="goods_list">
          <md-scroll-view ref="b_g_scrollView" :scrolling-x="false" :auto-reflow="true" manual-init @end-reached="handleGetGoodsMore">
            <!-- <md-scroll-view-refresh roller-color="#31B158" slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }" :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive" ></md-scroll-view-refresh> -->
            <div class="goods_items">
              <div
                :class="item.id == g_activeGood ? 'goods_item active':'goods_item'"
                v-for="(item,index) in g_goodsList"
                :key="index"
                @click.stop="selectGoods(item)"
              >
                <div class="goods_item_name_type">
                  <div class="goods_item_name mand-ellipsis">{{item.name}}</div>
                  <div class="goods_item_type" v-if="item.goods_type != 2">
                    <span class="item_type_zy" v-if="item.type == 1">自</span>
                    <span class="item_type_dm" v-if="item.type == 2">代</span>
                  </div>
                </div>
                <div class="goods_item_stock mand-ellipsis" v-if="item.goods_type != 2 && item.bale == 1">
                  库存：<span :style="Number(item.last_total_num)<0?'color:#f00':'color:#31B158'"
                  >{{item.last_total_num*1}}</span> {{unit_list[item.num_unit-1].name}}
                </div>
                <div class="goods_item_stock mand-ellipsis" v-if="item.goods_type != 2 && item.bale == 2">
                  库存：<span :style="Number(item.lase_num)<0?'color:#f00':'color:#31B158'"
                  >{{item.lase_num*1}}</span> {{unit_list[item.num_unit-1].name}}(<span :style="Number(item.last_total)<0?'color:#f00':'color:#31B158'" >{{item.last_total*1}}</span>
                  公斤)
                </div>
                <div class="goods_item_stock mand-ellipsis" v-if="item.goods_type != 2 && item.bale != 1 && item.bale != 2">
                  库存：<span :style="Number(item.last_total)<0?'color:#f00':'color:#31B158'" >{{item.last_total*1}}</span> 公斤
                </div>
                <div class="goods_item_stock mand-ellipsis" v-if="item.goods_type == 2">
                  <div v-if="item.type == 1">{{Number(item.num)}} x {{Number(item.price)}}元/个</div>
                  <div v-if="item.type == 2">{{Number(item.price)}}元</div>
                </div>
                <div class="goods_item_stock mand-ellipsis" v-if="b_active.btn_name == 'cate'">货主：<span v-if="item.supplier_name">{{item.supplier_name || ''}}</span></div>
              </div>
            </div>
            <md-scroll-view-more :finished-text="g_goodsList.length>0?'全部已加载':'暂无数据'" slot="more" :is-finished="g_isFinished" ></md-scroll-view-more>
          </md-scroll-view>
        </div>
        <div class="goods_index brt4" v-if="g_goodsKey&&g_goodsKey.length>10">
          <span @click="changeFirstName('')" :class="g_listQuery.first === ''?'active':''">全部</span>
          <div>
            <span @click="changeFirstName(item.first_name)" v-for="(item,index) in g_goodsKey" :key="index" :class="g_listQuery.first == item.first_name?'active':''">{{item.first_name}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 购物车 -->
    <div class="shop_box">
      <!-- 选择买家功能 -->
      <div class="shop_buyer brbl4">
        <div class="shop_buyer_select">
          <selectBuyer ref="selectBuyer" @finish="handleSelectBuyer"></selectBuyer>
          <!-- <el-select v-model="s_active.buyer_id" filterable placeholder="请选择" @visible-change="handleSelectBuyerShow" @change="handleSelectBuyer" popper-class="openOrderSelect" :popper-append-to-body="false" style="width:3.6rem">
            <el-option
              v-for="item in y_list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-show="item.id != 1">
            </el-option>
          </el-select> -->
        </div>
        <div class="shop_buyer_add" @click="ab_popShow = true">新增买家</div>
        <!-- 打印按钮 -->
        <div class="shop_print" :dot="ws_showDot" @click="handleRefresh">
          <!-- <img src="./../../../assets/img/work/open/print.png" alt /> -->
          <i class="iconfont icon-shuaxin" style="font-size:0.28rem;"></i>
        </div>
      </div>
      <!-- 买家列表 -->
      <div class="shop_buyer_list">
        <div class="shop_buyer_list_l">
          <div
            :class="item.main_sn == s_active.main_sn ? 'shop_buyer_item active':'shop_buyer_item'"
            v-for="(item,index) in s_shopList"
            :key="index"
            :id="'shop_'+item.main_sn"
            @click="changeShop(item)"
          >
            <div class="shop_buyer_item_name"> <span class="mand-ellipsis">{{item.buyer_name}}</span></div>
            <div class="gaidan" v-if="item.before_sn">改</div>
          </div>
        </div>
        <div class="shop_buyer_list_r">
          <div class="shop_buyer_item" @click="addShop({id:'1',name:'临时客户'})">
            <div class="shop_buyer_item_name">
              <span>
                <i class="iconfont icon-tianjia" style="font-size:0.2rem"></i> 临时客户
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 购物车 -->
      <div class="shop_list">
        <!-- 表头 -->
        <div class="shop_list_head shop_goods_item">
          <div>商品名称</div>
          <div>数量/重量</div>
          <div>单价</div>
          <div>小计(元)</div>
          <div></div>
        </div>
        <!-- 商品 -->
        <div class="shop_list_goods">
          <div class="shop_goods_item" v-for="(item,index) in s_active.shop_goods" :key="index" @click.stop="item.is_bind_goods?'':updateGoods(item)">
            <div class="mand-ellipsis">{{item.name}}</div>
            <!-- 数量重量 -->
            <div class="mand-ellipsis">
              <span v-if="item.goods_type == 1 && item.bale == 1">{{item.num*1}}{{unit_list[item.num_unit-1].name}}</span>
              <span v-if="item.goods_type == 1 && item.bale != 1">{{item.weight*1}}公斤</span>
              <span v-if="item.goods_type == 2 && item.type == 1">{{item.num*1}}个</span>
              <span v-if="item.goods_type == 2 && item.type != 1">--</span>
            </div>
            <!-- 单价 -->
            <div class="mand-ellipsis">
              <span v-if="item.goods_type == 1 && item.bale == 1">{{item.price}}元/{{unit_list[item.num_unit-1].name}}</span>
              <span v-if="item.goods_type == 1 && item.bale != 1">{{item.price}}元/公斤</span>
              <span v-if="item.goods_type == 2 && item.type == 1">{{item.price}}元/个</span>
              <span v-if="item.goods_type == 2 && item.type != 1">--</span>
            </div>  
            <div class="mand-ellipsis">
              <span v-if="item.goods_type == 1 && item.bale == 1">{{(Math.round(item.price * item.num * 100)/100).toFixed(2)}}</span>
              <span v-if="item.goods_type == 1 && item.bale != 1">{{(Math.round(item.price * item.weight * 100)/100).toFixed(2)}}</span>
              <span v-if="item.goods_type == 2 && item.type == 1">{{(Math.round(item.price * item.num * 100)/100).toFixed(2)}}</span>
              <span v-if="item.goods_type == 2 && item.type != 1">{{(Math.round(item.price * item.num * 100)/100).toFixed(2)}}</span>
            </div>
            <div class="mand-ellipsis" @click.stop="item.is_bind_goods?'':handleShopGoodDelete(item)">
              <i v-if="!item.is_bind_goods" class="iconfont icon-shanchu" style="color:#F4584D;font-size:0.24rem;font-weight:400"></i>
            </div>
          </div>
        </div>
        <!-- 结账 -->
        <div class="shop_total">
          <div class="shop_total_remarks">
            <div class="shop_total_num">重量:{{s_total.weight}}公斤，数量:{{s_total.num}}件</div>
            <!-- <div class="shop_remarks"> </div> -->
          </div>
          <div class="shop_total_tool">
            <div class="shop_total_amount">
              <div>
                总计：
                <span>{{s_total.amount}}</span> 元
              </div>
              <!-- <div class>
                已选：
                <span>{{s_total.ln}}</span>种
              </div> -->
            </div>
            <div class="shop_total_btn">
              <div class="shop_total_btn_delete" @click="handleShopDelete" v-if="s_active.main_sn">
                <i class="iconfont icon-shanchu" style="color:#F4584D;font-size:0.36rem;"></i>
              </div>
              <div class="shop_total_btn_print" :disabled="s_total.ln == 0" @click="handlePrint">打印</div>
              <div class="shop_total_btn_submit" :disabled="s_total.ln == 0" @click="handleSubmitOrder">下单</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 修改规格数量 -->
    <div class="pop_changeGood" :show="cg_popShow == true" @click.stop="cg_popShow = true">
      <div class="pop_changeGood_box">
        <!-- 标题 -->
        <div class="pop_changeGood_header">
          <div class="pop_changeGood_header_back" @click.stop="cg_popShow = false">
            <i class="iconfont icon-shangchuanicon-fuben"></i>
          </div>
          <div class="pop_changeGood_header_name mand-ellipsis">
            <span>{{cg_good.name}}</span>
            <span class="goods_item_type">
              <span class="goods_item_type_1" v-if="cg_good.bale ==1">定装</span>
              <span class="goods_item_type_2" v-if="cg_good.bale ==2">非定装</span>
              <span class="goods_item_type_3" v-if="cg_good.bale ==3">散装</span>
              <span class="goods_item_type_4" v-if="cg_good.goods_type ==2">附加费</span>
            </span>
          </div>
          <!-- <div class="pop_changeGood_header_btn">
            按钮组
          </div>-->
        </div>
        <!-- 商品信息 -->
        <div class="pop_changeGood_desc">
          <!-- <div v-if="cg_good.goods_type == 1">批次号：{{cg_good.batch}}</div> -->
          <div v-if="cg_good.goods_type == 1 && (cg_good.bale == 1 )">
            规格：{{cg_good.bale_num}} 公斤/{{unit_list[cg_good.num_unit-1].name}}
          </div>
        </div>
        <!-- 信息修改 -->
        <div class="pop_changeGood_info">
          <!-- 商品 -->
          <div class="pop_changeGood_info_box" v-if="cg_good.goods_type == 1">
            <!-- 数量 -->
            <div class="pop_changeGood_info_inputBox" v-if="cg_good.bale == 1 || cg_good.bale == 2" :focus="cg_key.active_name == 'num'" @click="selectGoodInput('num',2)">
              <span>数量</span>
              <input type="text" v-model="cg_changeData.num" readonly/>
              <span>{{unit_list[cg_good.num_unit-1].name}}</span>
            </div>
            <!-- 重量 -->
            <div class="pop_changeGood_info_inputBox" v-if="cg_good.bale == 2 || cg_good.bale == 3" :focus="cg_key.active_name == 'weight'" @click="selectGoodInput('weight',3)">
              <span>重量</span>
              <input type="text" v-model="cg_changeData.weight" readonly />
              <span>公斤</span>
            </div>
            <!-- 单价 -->
            <div class="pop_changeGood_info_inputBox" :focus="cg_key.active_name == 'price'" @click="selectGoodInput('price',2)">
              <span>单价</span>
              <input type="text" v-model="cg_changeData.price" readonly :placeholder="cg_good.proposed_price"/>
              <span v-if="cg_good.bale == 1">元/{{unit_list[cg_good.num_unit-1].name}}</span>
              <span v-if="cg_good.bale == 2 || cg_good.bale == 3">元/公斤</span>
            </div>
          </div>
          <!-- 附加费 -->
          <div class="pop_changeGood_info_box" v-if="cg_good.goods_type == 2">
            <!-- 收费/退费 -->
            <!-- <div class="fee_btns">
              <span :class="cg_changeData.pn == 1?'active':''" @click="cg_changeData.pn = 1">收费</span>
              <span :class="cg_changeData.pn == -1?'active':''" @click="cg_changeData.pn = -1">退费</span>
            </div> -->
            <!-- 数量 -->
            <div class="pop_changeGood_info_inputBox" v-if="cg_good.type == 1 " :focus="cg_key.active_name == 'num'" @click="selectGoodInput('num',2)">
              <span>数量</span>
              <input type="number" v-model="cg_changeData.num" readonly />
              <span>个</span>
            </div>
            <!-- 单价 -->
            <div class="pop_changeGood_info_inputBox" v-if="cg_good.type == 1 " :focus="cg_key.active_name == 'price'" @click="selectGoodInput('price',2)">
              <span>单价</span>
              <input type="number" v-model="cg_changeData.price" readonly />
              <span>元/个</span>
            </div>
            <!-- 总额 -->
            <div class="pop_changeGood_info_inputBox" v-if="cg_good.type == 2 " :focus="cg_key.active_name == 'price'" @click="selectGoodInput('price',2)">
              <span>总额</span>
              <input type="number" v-model="cg_changeData.price" readonly />
              <span>元</span>
            </div>
          </div>
        </div>
        <!-- 键盘 -->
        <div class="pop_changeGood_keyBoard">
          <KeyBoard ref="goodKeyBoard" @finish="handleChangeGoodFinish" :k_decimal="cg_key.decimal" v-model="cg_key.value" :k_finish_disabled="cg_key.finish_disabled" k_finish_text="确认" @input="handleChangeGoodInput">
            <template slot="diy_btn">
              <div class="diy_btn" @click="handleChangeGoodNextBtn"> 
                <button>下一项</button>
              </div>
            </template>
          </KeyBoard>
        </div>
      </div>
    </div>

    <!-- 添加买家 -->
    <addBuyer :pop_show="ab_popShow" @cancel="ab_popShow = false" />

    <!-- 下单模块 -->
    <submitOrder ref="submitOrder" :pop_print="so_print" :pop_show="so_popShow" :dataJson="so_orderJson" :buyerList="JSON.stringify(y_list)" @cancel="handleOrderSubmitCancel"/>
  </div>
</template>

<script>
import addBuyer from "./addBuyer";
import submitOrder from "./submitOrder";
import selectBuyer from "./../buyer/selectBuyer";
import KeyBoard from "@/components/KeyBoard";
import {longtimestampToTime} from '@/utils/timestamp'
import Cookies from "@/utils/Cookies";
import {init_getBatch,init_getCate,fee_getList,goods_getList, shop_getList,shop_getDetail,shop_create,shop_delete,shop_goods_add,shop_goods_update, shop_goods_delete ,shop_check_delete,buyer_list,orderPrint, ws_url } from "@/api/work/open";
export default {
  name: "openIndex",
  components: {
    submitOrder,
    addBuyer,
    KeyBoard,
    selectBuyer
  },
  watch:{
    "s_active.shop_goods":{
        handler: function() {
          this.computeTotal()
        },
        deep: true
     },
     "s_active.main_sn":{
        handler: function(newval,oldval) {
          if(newval){
            for (let i = 0; i < this.s_shopList.length; i++) {
              const item = this.s_shopList[i];
              if(item.main_sn == newval){
                this.s_active.before_sn = item.before_sn
              }
            }
            this.$nextTick(()=>{
              // console.log(document.getElementById("shop_"+ newval).offsetParent)
              // setTimeout(()=>{
                // document.getElementById("shop_"+ newval).scrollIntoView({ behavior: "smooth", block: "center" });
              // },200)
            })
          }
        },
        deep: true
     },
    "cg_popShow":{
        handler: function(newval,oldval) {
          if (!newval) {
            this.g_activeGood = ''
            this.cg_good = {}
            this.cg_changeData = {
              pn:1,
              num:'',
              weight:'',
              price:''
            }
            this.cg_key.value = ''
            this.cg_key.active_name = ''
            this.$refs.goodKeyBoard.clear()
          }
        },
        deep: true
     },
    "cg_key.active_name":{
        handler: function(newval,oldval) {
          this.cg_changeData.num = String(Number(this.cg_changeData.num))
          this.cg_changeData.weight = String(Number(this.cg_changeData.weight))
          this.cg_changeData.price = String(Number(this.cg_changeData.price))
        },
        deep: true
     },
  },
  
  beforeRouteEnter(to,from, next){
    next(vm=>{
      if (from.name == "public_scan" && from.meta.backData.str) {
        vm.$refs.submitOrder.posPay(from.meta.backData.str)
      }
    })
  },
  data() {
    return {
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      /**
       * 批次模块的变量 b_ 开头 batch
       */
      b_activeBatch: "", // 当前批次
      b_active:{
        btn_name:'',
        batch:0,
        cate:''
      },
      b_batchList:[],
      b_b_isFinished:false,
      b_b_listQuery:{
        page:1,
        pageSize:50,
      },
      b_c_isFinished:false,
      b_cateList:[],
      b_c_listQuery:{
        page:1,
        pageSize:50,
      },

      /**
       * 商品模块的变量 g_ 开头 goods
       */
      g_activeGood: "",
      g_goodsList:[],
      g_goodsKey:[],
      g_isFinished:false,
      g_listQuery:{
        page:1,
        pageSize:50,
        name:'',
        batch_id:'',
        cate_id:'', 
        first:'',
      },

      /**
       * 购物车模块的变量 s_ 开头 shop
       */
      // 正在活动的数据
      s_active:{
        buyer_id:"1",
        buyer_name:"临时买家",
        car_no:'',
        main_sn:'',
        shop_goods:[], // 当前商品列表
        remarks:[], // 备注信息
      },
      s_shopList:[],
      s_total:{
        weight:0,
        num:0,
        amount:0,
        ln:0
      },

      /**
       * 选择买家模块的变量 y_ 开头 buyer
       */
      y_list:[],

      /**
       * 修改商品信息模块的变量 cg_ 开头 changeGoods
       */
      cg_popShow: false,
      // 当前选择的商品
      cg_good:{},
      cg_changeData:{
        pn:1, // 收费1  退费-1
        weight:'',
        num:'',
        price:'',
      },
      cg_loading:true,

      // key
      cg_key:{
        active_name:'',
        value:'',
        decimal:'',
        finish_disabled:true
      },

      /**
       * 添加买家弹窗显示
       */
      ab_popShow: false,
      /**
       * 下单模块的变量 so_ 开头 submitOrder
       */
      so_popShow: false,
      so_orderJson:'',
      so_print:'',

      /**
       * loading
       */
      loading:{
        print:true
      },

      // webscoket 数据 ws_ 开头 ws
      ws: null, //长连接对象
      ws_count: 0, //长连接次数
      ws_t: null, //长连接的定时器
      ws_showDot: false, //显示红点
      ws_idGather: {}
    };
  },
  created() {
    // 初始化批次数据
    this.changeTab("batch");

    // webscoket启动
    // this.connection();
  },
  mounted() {
    this.getShopList()
    // this.getBuyerList()
  },
  methods: {
    hidePop(){
      this.cg_popShow = false
    },
    /**
     * 批次模块的函数 -------------------
     */
    // 初始化数据接口
    changeTab(name){
      this.b_active.btn_name = name
      this.g_isFinished = true
      this.g_listQuery.page = 1
      this.g_goodsList = []
      try { 
        this.$refs.b_g_scrollView.scrollTo(0,0) 
      } catch (error) {}
      // 切换到批次
      if(name == 'batch'){
        if(this.g_listQuery.batch_id){
          this.getGoods()
        }else{
          this.b_b_listQuery.page = 1
          this.getBatch()
        }
      }else if(name == 'cate'){
        if((this.g_listQuery.cate_id+'').length>0){
          this.getGoods()
        }else{
          this.b_c_listQuery.page = 1
          this.getCate()
        }
      }else if(name == 'fee'){
        this.getFee()
      }
    },

    // 获取批次数据
    getBatch() {
      this.b_b_isFinished = false
      init_getBatch(this.b_b_listQuery).then(res=>{
        if(res.code == 200){
          if(this.b_b_listQuery.page == 1) this.b_batchList = []
          this.b_batchList = this.b_batchList.concat(res.data.list.batches)
          if(this.b_batchList.length>0){
            if(this.g_listQuery.batch_id.length<1){
              this.g_goodsList = res.data.list.batches[0].goods.items
              this.g_goodsKey = res.data.list.batches[0].goods.first
              this.g_listQuery.batch_id = res.data.list.batches[0].id
              this.$refs.b_b_scrollView.scrollTo(0,0)
            }
            // 请求商品
            this.getGoods()
          }else{
            this.g_goodsList = []
            this.g_isFinished = true
            this.g_goodsKey = []
            this.g_listQuery.batch_id = ''
          }

          // 判断有没有结束
          if(this.b_batchList.length >= res.data.totalCount || res.data.list.batches.length == 0){
            this.b_b_isFinished = true;
          }else{
            this.b_b_listQuery.page ++ 
            this.b_b_isFinished = false;
          }
          this.$refs.b_b_scrollView.init()
          this.$refs.b_b_scrollView.finishLoadMore()
        }
      })
    },
    // 获取更多批次
    handleGetBatchMore(){
      if (this.b_b_isFinished) {
        return
      }
      this.$refs.b_b_scrollView.finishLoadMore()
      this.getBatch()
    },
    // 获取分类数据
    getCate() {
      this.b_c_isFinished = false
      init_getCate(this.b_c_listQuery).then(res=>{
        if(res.code == 200){
          if(this.b_c_listQuery.page == 1) this.b_cateList = []
          this.b_cateList = this.b_cateList.concat(res.data.list)
          if(this.b_cateList.length>0){
            if((this.g_listQuery.cate_id.length+"")<1){
              this.g_goodsList = res.data.list[0].goods.items
              this.g_goodsKey = res.data.list[0].goods.first
              this.g_listQuery.cate_id = res.data.list[0].id
              this.$refs.b_c_scrollView.scrollTo(0,0)
            }
            // 请求商品
            this.getGoods()
          }else{
            this.g_goodsList = []
            this.g_isFinished = true
            this.g_goodsKey = []
            this.g_listQuery.cate_id = ''
          }

          // 判断有没有结束
          if(this.b_cateList.length >= res.data.totalCount || res.data.list.length == 0){
            this.b_c_isFinished = true;
          }else{
            this.b_c_listQuery.page ++ 
            this.b_c_isFinished = false;
          }
          this.$refs.b_c_scrollView.init()
          this.$refs.b_c_scrollView.finishLoadMore()
        }
      })
    },
    // 获取附加费
    getFee(item){
      this.g_listQuery.name = ""
      this.g_listQuery.first = ""
      fee_getList(this.g_listQuery).then(res=>{
        if(res.code == 200){
          this.g_goodsList = res.data.goods
          this.g_goodsKey = res.data.first
          this.g_isFinished = true
        }
      })
    },
    // 切换批次
    changeBatch(item) {
      this.b_active.btn_name = "batch"
      this.g_listQuery.page = 1
      this.g_listQuery.batch_id = item.id;
      this.g_listQuery.first = ""
      this.g_listQuery.name = ""
      this.g_goodsList = []
      try { this.$refs.b_g_scrollView.scrollTo(0,0) } catch (error) {}
      this.getGoods()
    },
    // 切换分类
    changeCate(item) {
      this.b_active.btn_name = "cate"
      this.g_listQuery.page = 1
      this.g_listQuery.cate_id = item.id;
      this.g_listQuery.first = ""
      this.g_listQuery.name = ""
      this.g_goodsList = []
      try { this.$refs.b_g_scrollView.scrollTo(0,0) } catch (error) {}
      this.getGoods()
    },



    /**
     * 商品模块的函数 --------------------
     */
    // 获取商品列表
    getGoods(){
      this.g_isFinished = false
      if(this.b_active.btn_name == 'fee'){
        fee_getList(this.g_listQuery).then(res=>{
          if(res.code == 200){
            this.g_goodsList = res.data.goods
            this.g_goodsKey = res.data.first
            this.g_isFinished = true
          }
        })
      }else{
        var g_listQuery = JSON.parse(JSON.stringify(this.g_listQuery))
        if(this.b_active.btn_name == "batch"){
          g_listQuery.cate_id = ''
        }else{
          g_listQuery.batch_id = ''
        }
        goods_getList(g_listQuery).then(res=>{
          if(res.code == 200 ){
            this.$refs.b_g_scrollView.init()
            if(this.g_listQuery.page == 1) {
              this.g_goodsList = []
            }
            this.g_goodsList = this.g_goodsList.concat(res.data.list.goods)
            this.g_goodsKey = res.data.list.first || []
            // 判断有没有结束
            if(this.g_goodsList.length >= res.data.totalCount || res.data.list.goods.length == 0){
              this.g_isFinished = true;
            }else{
              this.g_listQuery.page ++ 
              this.g_isFinished = false;
            }
            this.$nextTick(()=>{
              this.$refs.b_g_scrollView.finishLoadMore()
              if(this.g_listQuery.page == 1){
                try { this.$refs.b_g_scrollView.scrollTo(0,0) } catch (error) {}
              }
              // console.log(this.$refs.b_g_scrollView.getOffsets())
              // this.$refs.b_g_scrollView.scrollTo(this.$refs.b_g_scrollView.getOffsets(),0)
            })
          }
        })
      }
    },
    // 获取更多批次
    handleGetGoodsMore(){
      if (this.g_isFinished) {
        return
      }
      this.$refs.b_g_scrollView.finishLoadMore()
      this.getGoods()
    },

    // 搜索框内容变化
    handleGoodsSearch() {
      if((this.b_active.btn_name == 'cate' && this.g_listQuery.cate_id )|| (this.b_active.btn_name == 'batch' && this.g_listQuery.batch_id ) ||  this.b_active.btn_name == 'fee'){
        this.g_listQuery.page = 1
        this.getGoods()
      }
    },  
    // 切换首汉字
    changeFirstName(val){
      this.g_listQuery.first = val 
      this.g_listQuery.page = 1
      this.getGoods()
    },
    // 选择商品
    selectGoods(item) {
      this.cg_popShow = false
      if(!this.s_active.main_sn){
        this.$toast.failed("请先添加买家订单！")
        return false
      }
      // 用计时器处理 这个修改还没消失 就点了其他的 商品 数据无法及时重置
      setTimeout(()=>{
        this.g_activeGood = item.id;
        this.cg_good = item
        if(this.b_active.btn_name == "fee"){
          this.cg_good.goods_type = 2
          this.cg_changeData.pn = Number(this.cg_good.price) < 0?-1:1
          this.cg_changeData.num = Number(this.cg_good.num) + ''
          this.cg_changeData.weight = 0
          // this.cg_changeData.price = Math.abs(Number(this.cg_good.price)) + ''
          this.cg_changeData.price = Number(this.cg_good.price) + ''
        }else{
          this.cg_good.goods_type = 1
          this.cg_changeData.pn = 1
          this.cg_changeData.num = 0
          this.cg_changeData.weight = 0
          this.cg_changeData.price = Math.abs(Number(this.cg_good.proposed_price) || 0)
        }
        this.handleChangeGoodNextBtn()
        this.cg_popShow = true;
      },40)
    },
    // 编辑商品
    updateGoods(item){
      this.cg_good = item
      this.cg_changeData.pn = Number(item.price) < 0?-1:1
      this.cg_changeData.num = Number(item.num) + ''
      this.cg_changeData.weight = Number(item.weight) + ''
      this.cg_changeData.price = Number(item.price) + ''
      this.handleChangeGoodNextBtn()
      this.cg_popShow = true;
    },
    // 点击输入框
    selectGoodInput(name,decimal){
      this.cg_key.active_name = name 
      this.cg_key.decimal = decimal
      if(name == "price" && this.cg_good.goods_type == 1){
        this.cg_key.value = ''
      }else{
        this.cg_key.value = Number(this.cg_changeData[this.cg_key.active_name] )+''
      }
      this.$refs.goodKeyBoard.clear()
    },

    // 数据输入中
    handleChangeGoodInput(val){
      if(val === '0' && this.cg_key.active_name == "price" && this.cg_good.goods_type == 1 && this.cg_good.proposed_price ){
        this.cg_changeData[this.cg_key.active_name] = Math.abs(Number(this.cg_good.proposed_price)) + ''
      }else{
        this.cg_changeData[this.cg_key.active_name] = val
      }
      if(this.cg_key.active_name == "price" && this.cg_good.goods_type == 2){
        if(val == "-"){
          val = 0
        }
        this.cg_changeData[this.cg_key.active_name] = Math.abs(val) * this.cg_changeData.pn
      }
      if (this.checkChangeGoodValue(JSON.parse(JSON.stringify(this.cg_good)))) {
        this.cg_key.finish_disabled = false
      }else{
        this.cg_key.finish_disabled = true
      }
    },

    // 下一项按钮
    handleChangeGoodNextBtn(){
      if(this.cg_key.active_name == "" ){
        if(this.cg_good.goods_type == 1 && this.cg_good.bale == 3 ){
          this.selectGoodInput("weight",3)
        }else if(this.cg_good.goods_type == 2 && this.cg_good.type == 2){
          this.selectGoodInput("price",2)
        }else{
          this.selectGoodInput("num",2)
        }
      }else if(this.cg_key.active_name == "num"){
        if(this.cg_good.goods_type == 1 && this.cg_good.bale == 2){
          this.selectGoodInput("weight",3)
        }else{
          this.selectGoodInput("price",2)
        }
      }else if(this.cg_key.active_name == "weight"){
        this.selectGoodInput("price",2)
      }else if(this.cg_key.active_name == "price"){
        if (this.cg_good.goods_type == 2 && this.cg_good.type == 2) {
          this.selectGoodInput("price",2)
        }else{
          this.selectGoodInput("num",2)
        }
      }
      if (this.checkChangeGoodValue(JSON.parse(JSON.stringify(this.cg_good)))) {
        this.cg_key.finish_disabled = false
      }else{
        this.cg_key.finish_disabled = true
      }
    },

    // 校验输入的数据完整吗
    checkChangeGoodValue(s_d,prompt){
      if ( s_d.goods_type == 1 && (s_d.bale == 1 || s_d.bale == 2) && !(this.cg_changeData.num > 0)) { prompt?this.$toast.failed("请输入商品销售数量！"):''; return false; }
      if ( s_d.goods_type == 1 && (s_d.bale == 2 || s_d.bale == 3) && !(this.cg_changeData.weight > 0)) { prompt?this.$toast.failed("请输入商品销售重量！"):''; return false; }
      if ( s_d.goods_type == 1 &&  !(this.cg_changeData.price > 0)) { prompt?this.$toast.failed("请输入商品销售单价！"):''; return false; }
      if ( s_d.goods_type == 2 && s_d.type == 1 && !(this.cg_changeData.num > 0)) { prompt?this.$toast.failed("请输入附加费销售数量！"):''; return false; }
      return true
    },

    // 数据修改完成
    handleChangeGoodFinish(){
      if(!this.cg_loading){
        return false
      }
      this.cg_key.active_name = ''
      this.$refs.goodKeyBoard.clear()
      var s_d = JSON.parse(JSON.stringify(this.cg_good))
      if(!this.checkChangeGoodValue(s_d,true)){
        return false
      }

      s_d.num = this.cg_changeData.num
      s_d.weight = this.cg_changeData.weight
      s_d.price = Math.abs(this.cg_changeData.price) * this.cg_changeData.pn
      if(this.s_active.buyer_id == 1 && s_d.goods_type == 2 && s_d.price == 0){
        this.$toast.failed("临时客户不可购买该商品，请检查！");
        return false
      }
      
      var t_price =''
      if (s_d.goods_type == 1) {
        if (s_d.bale == 1) {
          t_price = (s_d.price * s_d.num).toFixed(2);
        } else {
          t_price = (s_d.price * s_d.weight).toFixed(2);
        }
      } else {
        if (s_d.type == 1) {
          t_price = (s_d.price * s_d.num).toFixed(2);
        } else {
          t_price = (s_d.price * 1).toFixed(2);
        }
      }
      this.cg_loading = false
      // console.log(12)
      // this.cg_popShow = false
      // 如果有这两个表示新增
      if(s_d.items_id && s_d.items_sn){
        shop_goods_update({id:s_d.items_id ,items_sn:s_d.items_sn,goods:JSON.stringify(s_d)}).then(res => {
          if (res.code == 200) {
            this.$playaudio(s_d.name+",："+t_price+"元")
            this.getShopGoods(this.s_active.main_sn); 
            this.cg_popShow = false
            setTimeout(()=>{
              this.cg_loading = true
            },100)
          }
        }).catch(err=>{
          this.cg_loading = true
        });
      }else{
        shop_goods_add({buyer_id:this.s_active.buyer_id,main_sn:this.s_active.main_sn,goods:JSON.stringify(s_d)}).then(res => {
          if (res.code == 200) {
            this.$playaudio(s_d.name+",："+t_price+"元")
            this.getShopGoods(this.s_active.main_sn); 
            this.cg_popShow = false
            setTimeout(()=>{
              this.cg_loading = true
            },100)
          }
        }).catch(err=>{
          this.cg_loading = true
        });
      }
    },

    /**
     * 购物车模块的函数 -------------------
     */
    // 切换买家
    changeShop(item) {
      this.s_active.main_sn = item.main_sn;
      this.s_active.buyer_id = item.buyer_id;
      this.s_active.buyer_name = item.buyer_name;
      this.s_active.car_no = item.car_no;
      this.getShopGoods(item.main_sn);
    }, 
    // 添加一个购物车
    addShop(buyer_info) {
      shop_create({buyer_id:buyer_info.id}).then(res=>{
        if(res.code == 200 ){
          this.getShopList(0)
        }
      }).catch(err=>{
        // 该买家还有订单未完成 跳转到这个订单
        if(err.code == 201){
          this.s_active.main_sn = err.data[0]
          this.getShopGoods(this.s_active.main_sn)
        }
      })
    },
    // 获取所有的订单列表
    getShopList(index=-1) {
      shop_getList().then(res=>{
        if(res.code == 200){
          this.ws_showDot = false
          this.s_shopList = res.data
          if(res.data.length>0){
            if(index>=0){
              this.s_active.main_sn = res.data[index-0]
            }
            var main_sn_i = 0
            for (let i = 0; i < res.data.length; i++) {
              const item = res.data[i];
              if(item.main_sn == this.s_active.main_sn){
                main_sn_i = i
              }
            }
            this.s_active.buyer_id = res.data[main_sn_i].buyer_id
            this.s_active.buyer_name = res.data[main_sn_i].buyer_name
            this.s_active.car_no = res.data[main_sn_i].car_no
            this.s_active.main_sn = res.data[main_sn_i].main_sn
            this.getShopGoods(this.s_active.main_sn)
          }else{
            this.s_active.buyer_id = '1'
            this.s_active.buyer_name = '临时买家'
            this.s_active.car_no = ''
            this.s_active.main_sn = ''
            this.s_active.shop_goods = []
            this.s_active.remarks = []
          }
        }
      })
    },
    // 获取订单的详情 需传入订单 main_sn
    getShopGoods(main_sn){
      shop_getDetail({main_sn}).then(res=>{
        if(res.code == 200){
          this.s_active.shop_goods = res.data.goods
          this.s_active.remarks = res.data.desc
        }
      })
    },
    
    // 刷新数据
    handleRefresh(){
      this.getShopList()
    },

    // 删除订单
    handleShopDelete(){
      this.$dialog.confirm({
        title: '确认',
        content: '确认删除 '+this.s_active.buyer_name +' 的订单吗？',
        confirmText: '确定',
        onConfirm: () => {
          shop_delete({main_sn:this.s_active.main_sn}).then(res=>{
            if(res.code == 200){
              this.getShopList()
            }
          })
        },
      })
    },

    // 删除商品
    handleShopGoodDelete(item){
      this.$dialog.confirm({
        title: '确认',
        content: '确认删除 '+item.name +' 吗？',
        confirmText: '确定',
        onConfirm: () => {
          shop_goods_delete({id:item.items_id}).then(res=>{
            if(res.code == 200){
              this.getShopGoods(item.main_sn)
            }
          })
        },
      })
    },
    // 下单
    handleSubmitOrder(){
      if(this.s_total.ln == 0){
        return false
      }
      // this.getBuyerList()
      // this.$toast.loading("下单中...", 0, true)
      // shop_check_delete({main_sn:this.s_active.main_sn,goods:JSON.stringify(this.s_active.shop_goods)}).then(res=>{
      //   if(res.code == 200 ){
      //     this.$toast.hide()
          this.so_orderJson = JSON.stringify(this.s_active)
          // 打印数据
          var p_sub_data = {
            shop_name:JSON.parse(Cookies.get("shopInfo")).shop_name || "",
            date: longtimestampToTime(new Date().getTime()),
            buyer_name:this.s_active.buyer_name,
            car_no:this.s_active.car_no || '',
            total_amount : this.s_total.amount,
            casher:JSON.parse(Cookies.get("shopInfo")).realname || "",
            tel:JSON.parse(Cookies.get("userInfo")).mobile || "",
            shop_goods:this.s_active.shop_goods
          }
          this.so_print = JSON.stringify(p_sub_data)
          this.so_popShow = true
        // }
      // })
    },
    // 结算结束的回调
    handleOrderSubmitCancel(type){
      if (type == 1) {
        this.s_active.main_sn = ''
        this.g_listQuery.page = 1
        this.getGoods()
      }
      this.so_print = JSON.stringify({})
      this.so_orderJson = JSON.stringify({})
      this.so_popShow = false
      this.getShopList()
    },

    /**
     * 买家相关的函数 -------------------
     */
    // 显示买家列表时获取买家列表数据
    // handleSelectBuyerShow(val) {
    //   if (val) {
    //     this.getBuyerList()
    //   }
    // },
    // 获取买家列表
    getBuyerList(){
      buyer_list().then(res=>{
        if(res.code == 200 ){
          var list = []
          for (const key in res.data.list) {
            if (res.data.list.hasOwnProperty(key)) {
              const item = res.data.list[key];
              list = list.concat(item)
            }
          }
          this.y_list = list
        }
      })
    },
    // 选择了一个买家
    handleSelectBuyer(data) {
      // for (let i = 0; i < this.y_list.length; i++) {
      //   const item = this.y_list[i];
      //   if(item.id == buyer_id){
      //     this.s_active.buyer_id = item.id
      //     this.s_active.buyer_name = item.name
      //     this.s_active.car_no = item.car_no
      //     this.addShop(item);
      //   }
      // }
      this.s_active.buyer_id = data.id
      this.s_active.buyer_name = data.name
      this.s_active.car_no = data.car_no
      this.addShop(data);
    },
    
    // 计算总价
    computeTotal() {
      var goods = this.s_active.shop_goods;
      var amount = 0;
      var weight = 0;
      var num = 0;
      var ln = 0
      for (let i = 0; i < goods.length; i++) {
        const item = goods[i];
        if (item.goods_type == 1) {
          ln ++ 
          if (item.bale == 1) {
            amount += Math.round(item.price * item.num * 100) / 100;
            weight += Math.round(item.bale_num * item.num * 1000) / 1000
            num += Number(item.num)
          } else {
            if(item.bale == 2){
              num += Number(item.num)
            }
            weight += Number(item.weight)
            amount += Math.round(item.price * item.weight * 100) / 100;
          }
        } else if (item.goods_type == 2) {
          ln ++;
          amount += Math.round(item.price * item.num * 100) / 100;
        }
      }
      this.s_total.weight = Math.round(weight * 1000) / 1000 || 0;
      this.s_total.num = Math.round(num * 100) / 100 || 0;
      this.s_total.amount = Math.round(amount * 100) / 100 || 0;
      this.s_total.ln = ln ;
    },

    
    // 打印
    handlePrint() {
      if (this.s_total.ln == 0) {
        return false;
      }
      if (!this.loading.print) {
        return false;
      }
      var remarks_list = this.s_active.remarks;

      var remarks = "";
      if (remarks_list && remarks_list.length > 0) {
        for (let i = 0; i < remarks_list.length; i++) {
          const item = remarks_list[i];
          remarks += item.user_name + "：" + item.desc + "\n";
        }
      }
      this.loading.print = false;
      var p_sub_data = {
        shop_name:JSON.parse(Cookies.get("shopInfo")).shop_name || "",
        date: longtimestampToTime(new Date().getTime()),
        buyer_name:this.s_active.buyer_name,
        car_no:this.s_active.car_no || '',
        total_amount : this.s_total.amount,
        casher:JSON.parse(Cookies.get("shopInfo")).realname || "",
        tel:JSON.parse(Cookies.get("userInfo")).mobile || "",
        shop_goods:this.s_active.shop_goods
      }
      this.$toast.loading('正在打印中')
      try {
        var result= plus.bridge.execSync('sunmiPrint','printTempOrder',[JSON.stringify(p_sub_data)])
        this.loading.print = true;
        this.$toast.hide()
      } catch (error) {
        orderPrint({
          goods: JSON.stringify(this.s_active.shop_goods),
          receivables: this.s_total.amount,
          remarks
        }).then(res => {
          if (res.code == 200) {
            this.loading.print = true;
            this.$toast.hide()
          }
        });
      }
    },
    //长连接
    connection() {
      let _this = this;
      _this.ws = new WebSocket(ws_url);

      _this.ws.onopen = function(e) {
        var ids = {
          uid:JSON.parse(Cookies.get("shopInfo")).uid,
          mid:JSON.parse(Cookies.get("shopInfo")).mid
        }
        _this.ws.send(JSON.stringify(ids))
      };
      _this.ws.onclose = function(e) {
        _this.reconnection();
      };
      _this.ws.onerror = function() {
        _this.reconnection();
      };
      _this.ws.onmessage = function(res) {
        let data = JSON.parse(res.data);
        if ( data.mid == JSON.parse(Cookies.get("shopInfo")).mid && data.from_uid != JSON.parse(Cookies.get("shopInfo")).uid ) {
          _this.ws_showDot = true;
        }
      };
    },
    //重连
    reconnection() {
      let _this = this;
      this.ws_count = this.ws_count + 1; // 1与服务器已经建立连接
      if (this.ws_count >= 1000 || this.ws.readyState == 1) {
        clearTimeout(this.ws_t);
      } else {
        // 2已经关闭了与服务器的连接
        if (this.ws.readyState == 3) {
          this.connection();
        } // 0正尝试与服务器建立连接,2正在关闭与服务器的连接
        this.ws_t = setTimeout(function() {
          _this.reconnection();
        }, 100);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    let _this = this;
    _this.ws.onclose = function() {
      //  console.log("关闭")
      clearTimeout(_this.ws_t);
    };
    _this.ws.close();
    clearTimeout(this.ws_t);
    next();
  },
};
</script>

<style lang="less" scoped>
  @import "./openIndex.less";
</style>


<style lang="less">
.openIndex{
  .shop_buyer_select{
    .el-select{
      input{
        font-size: 0.24rem !important;
        height: 0.48rem !important;
        color: #2c3e50;
        background-color: #e1e1e1;
        &.el-input__inner{
          border: none !important;
        }
      }
      .el-input__icon{
        font-size: 0.24rem !important;
        color: #888 !important;
      }
      .el-input__suffix{
        right: 0.1rem !important;
        .el-input__icon{
          height: 0.48rem;
          line-height: 0.48rem;
        }
      }
    }
    .el-select-dropdown{
      max-width: 5.8rem;
      height: 6rem;
      .el-select-dropdown__wrap{
        max-height: 6rem !important;
      }
      .el-select-dropdown__item{
        font-size: 0.22rem !important;
        line-height: 0.48rem !important;
        height: 0.48rem !important;
      }
    }
    .el-select-dropdown__empty{
      font-size: 0.22rem !important;
    }
  }
}
</style>